// === LOCAL STORAGE CART SYSTEM ===

// Sepeti getir
export const getCart = () => {
  return JSON.parse(localStorage.getItem("cart") || "[]");
};

// Sepeti kaydet
export const saveCart = (cart) => {
  localStorage.setItem("cart", JSON.stringify(cart));
};

// Ürün ekle
export const addToCart = (product) => {
  let cart = getCart();
  const index = cart.findIndex((item) => item.id === product.id);

  if (index !== -1) {
    cart[index].quantity += product.quantity || 1;
  } else {
    cart.push({ ...product, quantity: product.quantity || 1 });
  }

  saveCart(cart);
  window.dispatchEvent(new Event("storage")); // Navbar badge güncellesin
};

// Sepetteki ürün sayısını getir
export const getCartCount = () => {
  const cart = getCart();
  return cart.reduce((total, item) => total + item.quantity, 0);
};

// Sepette miktar güncelle
export const updateQuantity = (id, newQty) => {
  let cart = getCart();
  cart = cart.map((item) =>
    item.id === id ? { ...item, quantity: Math.max(1, newQty) } : item
  );
  saveCart(cart);
  window.dispatchEvent(new Event("storage"));
};

// Sepetten ürünü sil
export const removeFromCart = (id) => {
  let cart = getCart();
  cart = cart.filter((item) => item.id !== id);
  saveCart(cart);
  window.dispatchEvent(new Event("storage"));
};
